export default {
  history: 'History',
  version: 'Version',
};
